/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Price_Per_MonthInputs */

const en_plan_price_per_month = /** @type {(inputs: Plan_Price_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} /month`)
};

const es_plan_price_per_month = /** @type {(inputs: Plan_Price_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} /mes`)
};

/**
* | output |
* | --- |
* | "{price} /month" |
*
* @param {Plan_Price_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_price_per_month = /** @type {((inputs: Plan_Price_Per_MonthInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Price_Per_MonthInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_price_per_month(inputs)
	return en_plan_price_per_month(inputs)
});